import { Subject, Subscription } from 'rxjs';
import { Injectable } from "@angular/core";
import { APIRequestResponse } from "../model/RequestResponse";
import { DDPEnglishWords } from "../model/DDPEnglishWords";
import { SearchWord, SearchWordAll } from '../model/SearchWord';
import { PaginatedWords } from '../model/PaginatedWords';

@Injectable({ providedIn: 'root'})
export class DdpDataStore {
    isLoadingRecords: boolean = false;
    paginatedWords?: PaginatedWords[] = [];
    currentpage: number = 0;
    totalRecords?: number = 0;
    first: number = 0;
    rows: number = 15;
    pageNumber?: number = 1;
    resultFound: boolean = false;
    resultTextFor?: string = "";
    autoCompletionLoaded: boolean = true;
    autoCompletionLoadedAllWords: boolean = true;
    isLoadingWords: boolean = false;
    isSuggestionFound: boolean = true;
    isLoadingWordDetail: boolean = false;
    isOnList: boolean = false;
    isPlayingAudio: boolean = false;
    wordDetailsCount: number = 0;
    totalPages: number = 0;
    pageNo: number = 1;
    paginatedWordsRequest: APIRequestResponse<string, number, number, number, DDPEnglishWords> = new APIRequestResponse<string, number, number, number, DDPEnglishWords>();
    wordDetailsList?: DDPEnglishWords[] = [];
    singleWordDetails?: DDPEnglishWords;
    wordsList: string[] = [];
    englishWordsListSub: Subject<APIRequestResponse<string, number, number, number, DDPEnglishWords>> = new Subject<APIRequestResponse<string, number, number, number, DDPEnglishWords>>();
    englishWordsLoadingSub: Subject<boolean> = new Subject<boolean>();
    returnFromDetailsPageSub: Subject<boolean> = new Subject<boolean>();
    callNextPageSub: Subject<number> = new Subject<number>();
    wordsListSubscription?: Subscription = undefined;
    callNextPageSubSubscription?: Subscription;
    getWordOfDaySubSubscription?: Subscription;
    wordsLoadingSubscription?: Subscription = undefined;
    isLoadingWordDetailSub: Subject<boolean> = new Subject<boolean>();
    paginatedSearchedAgain: Subject<boolean> = new Subject<boolean>();
    paginatedSearchedAgainSubscription?: Subscription = undefined;

    text = '';
    query = '';
    removeCharactersQuery = '';
    isLoadingList = false;
    allResults: SearchWord[] = [];
    allTheWords: SearchWordAll[] = [];
    selectedItem?: { id: any, word: string } | null = null;

    constructor() { }

}